import React, { useEffect, useState } from "react";
import { getUsers, getCurrentUser } from "../services/API";
import Layout from "./Layout";
import {
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    CircularProgress,
    Box,
    Typography,
    Chip,
    Button,
    IconButton,
} from "@mui/material";
import "../assets/css/usuarios.css";
import "bootstrap/dist/css/bootstrap.min.css";
import { styled } from "@mui/material/styles";
import { Link, useNavigate } from "react-router-dom";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import { deleteUser } from "../services/API";

const StyledTableRow = styled(TableRow)(({ theme }) => ({
    "&:nth-of-type(odd)": {
        backgroundColor: theme.palette.action.hover,
    },
    "&:last-child td, &:last-child th": {
        border: 0,
    },
    "&:hover": {
        backgroundColor: theme.palette.action.selected,
    },
}));

const StyledTableCell = styled(TableCell)(({ theme }) => ({
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.common.white,
    fontWeight: "bold",
    padding: "12px 16px",
}));

function Usuarios() {
    const [usuarios, setUsuarios] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [currentUserRole, setCurrentUserRole] = useState(null);
    const [currentUserID, setCurrentUserID] = useState(null);
    const navigate = useNavigate();

    const ROLES_MAP = {
        1: { name: "Super User", color: "error" },
        2: { name: "Administrator", color: "info" },
        3: { name: "Analyst", color: "warning" },
        4: { name: "Guest", color: "success" },
    };

    const USER_STATES_MAP = {
        1: { name: "Active", color: "success" },
        2: { name: "Suspended", color: "warning" },
        3: { name: "Unverified", color: "error" },
    };

    useEffect(() => {
        const fetchUsersData = async () => {
            setLoading(true);
            setError(null);
            try {
                const currentUser = await getCurrentUser();
                setCurrentUserRole(currentUser.userRolesId);
                setCurrentUserID(currentUser.id);

                const response = await getUsers();

                if (Array.isArray(response)) {
                    let filteredUsers = [];

                    if (currentUser.userRolesId === 1) {
                        filteredUsers = response;
                    } else if (currentUser.userRolesId === 2) {
                        console.log("Debug point 1")
                        filteredUsers = response.filter(user =>
                            user.userRolesId === 2 || user.userRolesId === 3 || user.userRolesId === 4
                        );
                        //console.log(filteredUsers);
                    } else if (currentUser.userRolesId === 3) {
                        console.log("Debug point 2")
                        filteredUsers = response.filter(user =>
                            user.userRolesId === 3 || user.userRolesId === 4
                        );
                        //console.log(filteredUsers);
                    } else {
                        filteredUsers = [];
                    }

                    /*if ((currentUser.userRolesId === 2 || currentUser.userRolesId === 3) && currentUser.profilesId) {
                        try {
                            const userProfiles = JSON.parse(currentUser.profilesId);
                            console.log("userProfiles",userProfiles);
                            if (Array.isArray(userProfiles)) {
                                filteredUsers = filteredUsers.filter(user => {
                                    if (user.userRolesId === 2 || user.userRolesId === 3) {
                                        if (user.profilesId) {
                                            try {
                                                const listedUserProfiles = JSON.parse(user.profilesId);
                                                return listedUserProfiles.some(profileId => userProfiles.includes(profileId));
                                            } catch (e) {
                                                console.warn(`Error parsing profilesId for user ${user.id}:`, e);
                                                return false;
                                            }
                                        }
                                        return false;
                                    }
                                    return true;
                                });
                            }
                        } catch (e) {
                            console.error("Error parsing currentUser.profilesId for filtering:", e);
                            filteredUsers = [];
                        }
                    }
                    console.log("ilteredUsers final",filteredUsers)*/
                    setUsuarios(filteredUsers);
                } else {
                    console.error("The getUsers response is not an array:", response);
                    setUsuarios([]);
                    setError("Unexpected data format received from server.");
                }
            } catch (err) {
                console.error("Error loading users:", err);
                setError("Error loading users. Please try again later.");
                setUsuarios([]);
            } finally {
                setLoading(false);
            }
        };

        fetchUsersData();
    }, []);

    const handleEdit = (userId) => {
        navigate(`/actualizar-usuario/${userId}`);
        //console.log("Editar usuario con ID:", userId);
    };

    const handleDelete = async (userId, firstName, lastName) => {
        //console.log("Delete usuario con ID:", userId);
        if (window.confirm(`Are you sure you want to delete user ${firstName} ${lastName} (Not reversible)`)) {
            await deleteUser(userId);
            setUsuarios(usuarios.filter(usuario => usuario.id !== userId));
            alert(`User ${userId} deleted.`);
        }
    };


    return (
        <Layout>
            <div className="app-container">
                <Box className="container mt-4" sx={{ padding: 3 }}>
                    <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 4 }}>
                        <Typography variant="h4" component="h2" gutterBottom sx={{ color: "primary.dark", mb: 0 }}>
                            Users List
                        </Typography>
                        {(currentUserRole === 1 || currentUserRole === 2 || currentUserRole === 3) && (
                            <Button
                                variant="contained"
                                color="primary"
                                component={Link}
                                to="/registrar-usuario"
                            >
                                Register User
                            </Button>
                        )}
                    </Box>

                    {loading ? (
                        <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", height: "200px" }}>
                            <CircularProgress />
                            <Typography variant="h6" sx={{ ml: 2 }}>Loading users...</Typography>
                        </Box>
                    ) : error ? (
                        <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", height: "200px", flexDirection: "column" }}>
                            <Typography variant="h6" color="error" gutterBottom>{error}</Typography>
                            <Typography variant="body1" color="text.secondary">
                                There was a problem loading the data. Check your connection or try again later.
                            </Typography>
                        </Box>
                    ) : usuarios.length > 0 ? (
                        <TableContainer component={Paper} elevation={3} sx={{ borderRadius: "8px", overflow: "hidden" }}>
                            <Table sx={{ minWidth: 750 }} aria-label="users table">
                                <TableHead>
                                    <TableRow>
                                        <StyledTableCell>#</StyledTableCell>
                                        <StyledTableCell align="left">First Name</StyledTableCell>
                                        <StyledTableCell align="left">Last Name</StyledTableCell>
                                        <StyledTableCell align="left">Email</StyledTableCell>
                                        <StyledTableCell align="left">Role</StyledTableCell>
                                        <StyledTableCell align="left">Status</StyledTableCell>
                                        {(currentUserRole === 1 || currentUserRole === 2 || currentUserRole === 3) && (
                                            <StyledTableCell align="center">Actions</StyledTableCell>
                                        )}
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {usuarios.map((usuario, index) => {
                                        const roleInfo = ROLES_MAP[usuario.userRolesId] || { name: "Unknown", color: "default" };
                                        const stateInfo = USER_STATES_MAP[usuario.userStatesId] || { name: "Unknown", color: "default" };

                                        return (
                                            <StyledTableRow key={usuario.id}>
                                                <TableCell component="th" scope="row">
                                                    {index + 1}
                                                </TableCell>
                                                <TableCell align="left">{usuario.firstName}</TableCell>
                                                <TableCell align="left">{usuario.lastName}</TableCell>
                                                <TableCell align="left">{usuario.email}</TableCell>
                                                <TableCell align="left">
                                                    <Chip label={roleInfo.name} color={roleInfo.color} size="small" variant="outlined" />
                                                </TableCell>
                                                <TableCell align="left">
                                                    <Chip label={stateInfo.name} color={stateInfo.color} size="small" variant="outlined" />
                                                </TableCell>
                                                {(currentUserRole === 1 || currentUserRole === 2 || currentUserRole === 3) && (
                                                    <TableCell align="center">
                                                        <IconButton
                                                            aria-label="edit"
                                                            color="info"
                                                            onClick={() => handleEdit(usuario.id, usuario.firstName)}
                                                            sx={{ mr: 1 }}
                                                        >
                                                            <EditIcon />
                                                        </IconButton>
                                                        <IconButton
                                                            aria-label="delete"
                                                            color="error"
                                                            onClick={() => handleDelete(usuario.id, usuario.firstName, usuario.lastName)}
                                                            disabled={usuario.id === currentUserID}
                                                        >
                                                            <DeleteIcon />
                                                        </IconButton>
                                                    </TableCell>
                                                )}
                                            </StyledTableRow>
                                        );
                                    })}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    ) : (
                        <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", height: "200px", flexDirection: "column", border: "2px dashed #ccc", borderRadius: "8px", p: 3 }}>
                            <Typography variant="h6" color="text.secondary" gutterBottom>
                                No users registered
                            </Typography>
                            <Typography variant="body2" color="text.disabled">
                                There are no user records to display yet.
                            </Typography>
                        </Box>
                    )}
                </Box>
            </div>
        </Layout>
    );
}

export default Usuarios;
